import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getValidationsForDocumentId} from '../../../../../../../selectors/Forms/canvasFormSelectors';
import {ToastMessageVariants, validationTypes} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import {setFormV2ToasterVisibility} from '../../../../../../../actions/toastactions';

export default function ProfileBanner(document) {
	const validations = useSelector((state) => getValidationsForDocumentId(state, document?.document?.id));
	const engagement = useSelector((state) => state.engagement);
	const dispatch = useDispatch();

	useEffect(() => {
		const hasChangesNotSubmittedValidation =
			validations?.length > 0 &&
			validations.some((t) => t.validationTypeId === validationTypes.ProfileV2ChangeNotSubmitted);

		if (hasChangesNotSubmittedValidation && engagement?.isProfileComplete) {
			dispatch(
				setFormV2ToasterVisibility(true, ToastMessageVariants.Warning, labels.profileV2ChangeNotSubmittedBannerMessage)
			);
		}
	}, [validations, engagement, dispatch]);
}
